module.exports = __webpack_public_path__ + "img/agent.b163546a.png";